import * as types from "./types";

export function updateSelectedResource(selectedResource) {
    return { type: types.UPDATE_SELECTED_RESOURCE, selectedResource };
}

export function clearSelectedResource() {
    return { type: types.CLEAR_SELECTED_RESOURCE };
}